<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="550px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t(`Edit Bank's Information`) }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-layout row wrap>
              <v-flex xs12 class="pa-2">
                <v-text-field
                  v-model="viewInfo.account_no"
                  :label="`${$t('Account No.')} *`"
                  name="account_no"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('account_no')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs12 class="pa-2">
                <v-text-field
                  v-model="viewInfo.bank_name"
                  :label="`${$t('Bank Name')} *`"
                  name="bank_name"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('bank_name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs12 pa-2>
                <p>{{ `${$t('Currency Type')} *` }}</p>
                <v-radio-group v-model="viewInfo.currency_type" name="currency_type" v-validate="'required'" row>
                  <v-radio :label="$t('USD')" value="USD" color="blue" />
                  <v-radio :label="$t('IQD')" value="IQD" color="blue" />
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'banks/getBankInfo'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateBankInfo: 'banks/updateBankInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.viewInfo.bank_id, formData }

          this.updateBankInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped></style>
